import { Progress } from "@aidron/aidron-ds";

import { LOADING_CONTENT_TYPE } from "./loading.content.constants";

import PropTypes from 'prop-types';

export function LoadingContent({ label, type, mode = "" }) {
    const renderContent = () => {
        switch (type) {
            case LOADING_CONTENT_TYPE.SHARED_CONTEXT:
                return (
                    <div 
                    style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '16px'}}>
                        <Progress circular size={48} />
                        <span style={{
                            color: '#666',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                           {label}
                        </span>
                    </div>
                )
            
            case LOADING_CONTENT_TYPE.LOCAL_PAGE_STATE:
                return (
                    <div 
                    style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        gap: '16px'}}>
                        <Progress circular size={48} />
                        <span 
                            style={{
                            color: '#666',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                            {label}
                        </span>
                    </div>
                )

            case LOADING_CONTENT_TYPE.API_PAGE_DATA:
                return (
                    <div style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        display: "flex",
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '32px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.8)',
                        gap: '16px'
                    }}>
                        <Progress circular size={48} />
                        <span style={{
                            color: '#666',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                            {label}
                        </span>
                    </div>
                );

            case LOADING_CONTENT_TYPE.VIEW_DATA:
                return (
                    <>
                        <div className="d-flex justify-content-center align-items-center width-40px-on-progress">
                            <Progress circular /> 
                        </div>
                
                        <div>
                            {label}
                        </div>
                    </>
                )
        }
    };

    if(mode === LOADING_CONTENT_TYPE.VIEW_DATA) {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "auto" }}>
                {renderContent()}
            </div>
        )
    }

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(2px)'
        }}>
            {renderContent()}
        </div>
    );
};

LoadingContent.propTypes = {
    label: PropTypes.string,
    type: PropTypes.oneOf([LOADING_CONTENT_TYPE.getAll()]).isRequired,
    mode: PropTypes.string
};
